import { Container } from '@styles/helpers'
import { colors } from '@styles/vars'
import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

export default function NavigationLow({ padding, children }: NavigationProps) {
    return (
        <NavigationWrapper padding={padding}>
            <NavigationContainer>
                {children}
            </NavigationContainer>
        </NavigationWrapper>
    )
}

// COMPONENTS
NavigationLow.Item = ({ label, to }: NavigationItemProps) => {
    return <NavLink exact to={to}>{label}</NavLink>
}

// STYLES
const NavigationWrapper = styled.div<{ padding?: string }>`
    border-bottom: 1px solid ${colors.border};
    padding: ${props => props.padding || "0px"};
`

const NavigationContainer = styled.div`
    display: flex;
    overflow-x: auto;
    overflow-y: hidden;

    a {
        display: block;
        color: ${colors.darkGrey};
        text-decoration: none;
        padding: 10px;
        border: 1px solid transparent;
        font-weight: 600;

        &:last-child {
            margin-left: 5px;
        }

        &:first-child {
            margin-right: 5px;
        }

        &:not(:first-child), &:not(:last-child) {
            margin-right: 5px;
            margin-left: 5px;
        }
    }

    a.active {
        color: ${colors.black};
        border: 1px solid ${colors.border};
        border-bottom: 1px solid #fff;
        background: #fff;
        margin-bottom: -1px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
`

// TYPES
interface NavigationProps {
    children: React.ReactNode
    padding?: string
}

interface NavigationItemProps {
    label: string
    to: string
}